import { render, staticRenderFns } from "./EditVote.vue?vue&type=template&id=51bc7320&scoped=true"
import script from "./EditVote.vue?vue&type=script&lang=js"
export * from "./EditVote.vue?vue&type=script&lang=js"
import style0 from "./EditVote.vue?vue&type=style&index=0&id=51bc7320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc7320",
  null
  
)

export default component.exports